import { useEffect, useState } from 'react';
import { getContactMetadata } from './services/contactService';

export const useContactChannelMasking = (): boolean => {
  const [maskChannelValues, setMaskChannelValues] = useState(false);

  useEffect(() => {
    let cancelled = false;

    void getContactMetadata()
      .then(metadata => {
        if (!cancelled) {
          setMaskChannelValues(metadata.maskChannelValues);
        }
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, []);

  return maskChannelValues;
};
